import { generateKeys } from '../utils';
const withdrawalBanksBrazil = {
    '001': { value: '001', label: 'BANCO DO BRASIL S.A (BB)' },
    '237': { value: '237', label: 'BRADESCO S.A' },
    '335': { value: '335', label: 'Banco Digio S.A' },
    '260': { value: '260', label: 'NU PAGAMENTOS S.A (NUBANK)' },
    '290': { value: '290', label: 'Pagseguro Internet S.A (PagBank)' },
    '380': { value: '380', label: 'PicPay Servicos S.A.' },
    '323': { value: '323', label: 'Mercado Pago - conta do Mercado Livre' },
    '237b': { value: '237', label: 'NEXT BANK' },
    '637': { value: '637', label: 'BANCO SOFISA S.A (SOFISA DIRETO)' },
    '077': { value: '077', label: 'BANCO INTER S.A' },
    '341': { value: '341', label: 'ITAÚ UNIBANCO S.A' },
    '104': { value: '104', label: 'CAIXA ECONÔMICA FEDERAL (CEF)' },
    '033': { value: '033', label: 'BANCO SANTANDER BRASIL S.A' },
    '212': { value: '212', label: 'BANCO ORIGINAL S.A' },
    '756': { value: '756', label: 'BANCOOB (BANCO COOPERATIVO DO BRASIL)' },
    '655': { value: '655', label: 'BANCO VOTORANTIM S.A' },
    '655b': { value: '655', label: 'NEON PAGAMENTOS S.A' },
    '041': { value: '041', label: 'BANRISUL – BANCO DO ESTADO DO RIO GRANDE DO SUL S.A' },
    '389': { value: '389', label: 'BANCO MERCANTIL DO BRASIL S.A' },
    '422': { value: '422', label: 'BANCO SAFRA S.A' },
    '070': { value: '070', label: 'BANCO DE BRASÍLIA (BRB)' },
    '136': { value: '136', label: 'UNICRED COOPERATIVA' },
    '741': { value: '741', label: 'BANCO RIBEIRÃO PRETO' },
    '739': { value: '739', label: 'BANCO CETELEM S.A' },
    '743': { value: '743', label: 'BANCO SEMEAR S.A' },
    '100': { value: '100', label: 'PLANNER CORRETORA DE VALORES S.A' },
    '096': { value: '096', label: 'BANCO B3 S.A' },
    '747': { value: '747', label: 'Banco RABOBANK INTERNACIONAL DO BRASIL S.A' },
    '748': { value: '748', label: 'SICREDI S.A' },
    '752': { value: '752', label: 'BNP PARIBAS BRASIL S.A' },
    '091': { value: '091', label: 'UNICRED CENTRAL RS' },
    '399': { value: '399', label: 'KIRTON BANK' },
    '108': { value: '108', label: 'PORTOCRED S.A' },
    '757': { value: '757', label: 'BANCO KEB HANA DO BRASIL S.A' },
    '102': { value: '102', label: 'XP INVESTIMENTOS S.A' },
    '348': { value: '348', label: 'BANCO XP S/A' },
    '340': { value: '340', label: 'SUPER PAGAMENTOS S/A (SUPERDITAL)' },
    '364': { value: '364', label: 'GERENCIANET PAGAMENTOS DO BRASIL' },
    '084': { value: '084', label: 'UNIPRIME NORTE DO PARANÁ' },
    '180': { value: '180', label: 'CM CAPITAL MARKETS CCTVM LTDA' },
    '066': { value: '066', label: 'BANCO MORGAN STANLEY S.A' },
    '015': { value: '015', label: 'UBS BRASIL CCTVM S.A' },
    '143': { value: '143', label: 'TREVISO CC S.A' },
    '062': { value: '062', label: 'HIPERCARD BM S.A' },
    '074': { value: '074', label: 'BCO. J.SAFRA S.A' },
    '099': { value: '099', label: 'UNIPRIME CENTRAL CCC LTDA' },
    '025': { value: '025', label: 'BANCO ALFA S.A.' },
    '075': { value: '075', label: 'BCO ABN AMRO S.A' },
    '040': { value: '040', label: 'BANCO CARGILL S.A' },
    '190': { value: '190', label: 'SERVICOOP' },
    '063': { value: '063', label: 'BANCO BRADESCARD' },
    '191': { value: '191', label: 'NOVA FUTURA CTVM LTDA' },
    '064': { value: '064', label: 'GOLDMAN SACHS DO BRASIL BM S.A' },
    '097': { value: '097', label: 'CCC NOROESTE BRASILEIRO LTDA' },
    '016': { value: '016', label: 'CCM DESP TRÂNS SC E RS' },
    '012': { value: '012', label: 'BANCO INBURSA' },
    '003': { value: '003', label: 'BANCO DA AMAZONIA S.A' },
    '060': { value: '060', label: 'CONFIDENCE CC S.A' },
    '037': { value: '037', label: 'BANCO DO ESTADO DO PARÁ S.A' },
    '159': { value: '159', label: 'CASA CREDITO S.A' },
    '172': { value: '172', label: 'ALBATROSS CCV S.A' },
    '085': { value: '085', label: 'COOP CENTRAL AILOS' },
    '114': { value: '114', label: 'CENTRAL COOPERATIVA DE CRÉDITO NO ESTADO DO ESPÍRITO SANTO' },
    '036': { value: '036', label: 'BANCO BBI S.A' },
    '394': { value: '394', label: 'BANCO BRADESCO FINANCIAMENTOS S.A' },
    '004': { value: '004', label: 'BANCO DO NORDESTE DO BRASIL S.A.' },
    '320': { value: '320', label: 'BANCO CCB BRASIL S.A' },
    '189': { value: '189', label: 'HS FINANCEIRA' },
    '105': { value: '105', label: 'LECCA CFI S.A' },
    '076': { value: '076', label: 'BANCO KDB BRASIL S.A.' },
    '082': { value: '082', label: 'BANCO TOPÁZIO S.A' },
    '286': { value: '286', label: 'CCR DE OURO' },
    '093': { value: '093', label: 'PÓLOCRED SCMEPP LTDA' },
    '273': { value: '273', label: 'CCR DE SÃO MIGUEL DO OESTE' },
    '157': { value: '157', label: 'ICAP DO BRASIL CTVM LTDA' },
    '183': { value: '183', label: 'SOCRED S.A' },
    '014': { value: '014', label: 'NATIXIS BRASIL S.A' },
    '130': { value: '130', label: 'CARUANA SCFI' },
    '127': { value: '127', label: 'CODEPE CVC S.A' },
    '079': { value: '079', label: 'BANCO ORIGINAL DO AGRONEGÓCIO S.A' },
    '081': { value: '081', label: 'BBN BANCO BRASILEIRO DE NEGOCIOS S.A' },
    '118': { value: '118', label: 'STANDARD CHARTERED BI S.A' },
    '133': { value: '133', label: 'CRESOL CONFEDERAÇÃO' },
    '121': { value: '121', label: 'BANCO AGIBANK S.A' },
    '083': { value: '083', label: 'BANCO DA CHINA BRASIL S.A' },
    '138': { value: '138', label: 'GET MONEY CC LTDA' },
    '024': { value: '024', label: 'BCO BANDEPE S.A' },
    '095': { value: '095', label: 'BANCO CONFIDENCE DE CÂMBIO S.A' },
    '094': { value: '094', label: 'BANCO FINAXIS' },
    '276': { value: '276', label: 'SENFF S.A' },
    '137': { value: '137', label: 'MULTIMONEY CC LTDA' },
    '092': { value: '092', label: 'BRK S.A' },
    '047': { value: '047', label: 'BANCO BCO DO ESTADO DE SERGIPE S.A' },
    '144': { value: '144', label: 'BEXS BANCO DE CAMBIO S.A.' },
    '126': { value: '126', label: 'BR PARTNERS BI' },
    '301': { value: '301', label: 'BPP INSTITUIÇÃO DE PAGAMENTOS S.A' },
    '173': { value: '173', label: 'BRL TRUST DTVM SA' },
    '119': { value: '119', label: 'BANCO WESTERN UNION' },
    '254': { value: '254', label: 'PARANA BANCO S.A' },
    '268': { value: '268', label: 'BARIGUI CH' },
    '107': { value: '107', label: 'BANCO BOCOM BBM S.A' },
    '412': { value: '412', label: 'BANCO CAPITAL S.A' },
    '124': { value: '124', label: 'BANCO WOORI BANK DO BRASIL S.A' },
    '149': { value: '149', label: 'FACTA S.A. CFI' },
    '197': { value: '197', label: 'STONE PAGAMENTOS S.A' },
    '142': { value: '142', label: 'BROKER BRASIL CC LTDA' },
    '184': { value: '184', label: 'BANCO ITAÚ BBA S.A' },
    '634': { value: '634', label: 'BANCO TRIANGULO S.A (BANCO TRIÂNGULO)' },
    '545': { value: '545', label: 'SENSO CCVM S.A' },
    '132': { value: '132', label: 'ICBC DO BRASIL BM S.A' },
    '298': { value: '298', label: 'VIPS CC LTDA' },
    '129': { value: '129', label: 'UBS BRASIL BI S.A' },
    '128': { value: '128', label: 'MS BANK S.A BANCO DE CÂMBIO' },
    '194': { value: '194', label: 'PARMETAL DTVM LTDA' },
    '310': { value: '310', label: 'VORTX DTVM LTDA' },
    '163': { value: '163', label: 'COMMERZBANK BRASIL S.A BANCO MÚLTIPLO' },
    '280': { value: '280', label: 'AVISTA S.A' },
    '146': { value: '146', label: 'GUITTA CC LTDA' },
    '279': { value: '279', label: 'CCR DE PRIMAVERA DO LESTE' },
    '182': { value: '182', label: 'DACASA FINANCEIRA S/A' },
    '278': { value: '278', label: 'GENIAL INVESTIMENTOS CVM S.A' },
    '271': { value: '271', label: 'IB CCTVM LTDA' },
    '021': { value: '021', label: 'BANCO BANESTES S.A' },
    '246': { value: '246', label: 'BANCO ABC BRASIL S.A' },
    '751': { value: '751', label: 'SCOTIABANK BRASIL' },
    '208': { value: '208', label: 'BANCO BTG PACTUAL S.A' },
    '746': { value: '746', label: 'BANCO MODAL S.A' },
    '241': { value: '241', label: 'BANCO CLASSICO S.A' },
    '612': { value: '612', label: 'BANCO GUANABARA S.A' },
    '604': { value: '604', label: 'BANCO INDUSTRIAL DO BRASIL S.A' },
    '505': { value: '505', label: 'BANCO CREDIT SUISSE (BRL) S.A' },
    '196': { value: '196', label: 'BANCO FAIR CC S.A' },
    '300': { value: '300', label: 'BANCO LA NACION ARGENTINA' },
    '477': { value: '477', label: 'CITIBANK N.A' },
    '266': { value: '266', label: 'BANCO CEDULA S.A' },
    '122': { value: '122', label: 'BANCO BRADESCO BERJ S.A' },
    '376': { value: '376', label: 'BANCO J.P. MORGAN S.A' },
    '473': { value: '473', label: 'BANCO CAIXA GERAL BRASIL S.A' },
    '745': { value: '745', label: 'BANCO CITIBANK S.A' },
    '120': { value: '120', label: 'BANCO RODOBENS S.A' },
    '265': { value: '265', label: 'BANCO FATOR S.A' },
    '007': { value: '007', label: 'BNDES (Banco Nacional do Desenvolvimento Social)' },
    '188': { value: '188', label: 'ATIVA S.A INVESTIMENTOS' },
    '134': { value: '134', label: 'BGC LIQUIDEZ DTVM LTDA' },
    '641': { value: '641', label: 'BANCO ALVORADA S.A' },
    '029': { value: '029', label: 'BANCO ITAÚ CONSIGNADO S.A' },
    '243': { value: '243', label: 'BANCO MÁXIMA S.A' },
    '078': { value: '078', label: 'HAITONG BI DO BRASIL S.A' },
    '111': { value: '111', label: 'BANCO OLIVEIRA TRUST DTVM S.A' },
    '017': { value: '017', label: 'BNY MELLON BANCO S.A' },
    '174': { value: '174', label: 'PERNAMBUCANAS FINANC S.A' },
    '495': { value: '495', label: 'LA PROVINCIA BUENOS AIRES BANCO' },
    '125': { value: '125', label: 'BRASIL PLURAL S.A BANCO' },
    '488': { value: '488', label: 'JPMORGAN CHASE BANK' },
    '065': { value: '065', label: 'BANCO ANDBANK S.A' },
    '492': { value: '492', label: 'ING BANK N.V' },
    '250': { value: '250', label: 'BANCO BCV' },
    '145': { value: '145', label: 'LEVYCAM CCV LTDA' },
    '494': { value: '494', label: 'BANCO REP ORIENTAL URUGUAY' },
    '253': { value: '253', label: 'BEXS CC S.A' },
    '269': { value: '269', label: 'HSBC BANCO DE INVESTIMENTO' },
    '213': { value: '213', label: 'BCO ARBI S.A' },
    '139': { value: '139', label: 'INTESA SANPAOLO BRASIL S.A' },
    '018': { value: '018', label: 'BANCO TRICURY S.A' },
    '630': { value: '630', label: 'BANCO INTERCAP S.A' },
    '224': { value: '224', label: 'BANCO FIBRA S.A' },
    '600': { value: '600', label: 'BANCO LUSO BRASILEIRO S.A' },
    '623': { value: '623', label: 'BANCO PAN' },
    '204': { value: '204', label: 'BANCO BRADESCO CARTOES S.A' },
    '479': { value: '479', label: 'BANCO ITAUBANK S.A' },
    '456': { value: '456', label: 'BANCO MUFG BRASIL S.A' },
    '464': { value: '464', label: 'BANCO SUMITOMO MITSUI BRASIL S.A' },
    '613': { value: '613', label: 'OMNI BANCO S.A' },
    '652': { value: '652', label: 'ITAÚ UNIBANCO HOLDING BM S.A' },
    '653': { value: '653', label: 'BANCO INDUSVAL S.A' },
    '069': { value: '069', label: 'BANCO CREFISA S.A' },
    '370': { value: '370', label: 'BANCO MIZUHO S.A' },
    '249': { value: '249', label: 'BANCO INVESTCRED UNIBANCO S.A' },
    '318': { value: '318', label: 'BANCO BMG S.A' },
    '626': { value: '626', label: 'BANCO FICSA S.A' },
    '270': { value: '270', label: 'SAGITUR CC LTDA' },
    '366': { value: '366', label: 'BANCO SOCIETE GENERALE BRASIL' },
    '113': { value: '113', label: 'MAGLIANO S.A' },
    '131': { value: '131', label: 'TULLETT PREBON BRASIL CVC LTDA' },
    '011': { value: '011', label: 'C.SUISSE HEDGING-GRIFFO CV S.A (Credit Suisse)' },
    '611': { value: '611', label: 'BANCO PAULISTA' },
    '755': { value: '755', label: 'BOFA MERRILL LYNCH BM S.A' },
    '089': { value: '089', label: 'CCR REG MOGIANA' },
    '643': { value: '643', label: 'BANCO PINE S.A' },
    '140': { value: '140', label: 'EASYNVEST - TÍTULO CV S.A' },
    '707': { value: '707', label: 'BANCO DAYCOVAL S.A' },
    '288': { value: '288', label: 'CAROL DTVM LTDA' },
    '101': { value: '101', label: 'RENASCENCA DTVM LTDA' },
    '487': { value: '487', label: 'DEUTSCHE BANK S.A BANCO ALEMÃO' },
    '233': { value: '233', label: 'BANCO CIFRA' },
    '177': { value: '177', label: 'GUIDE' },
    '633': { value: '633', label: 'BANCO RENDIMENTO S.A' },
    '218': { value: '218', label: 'BANCO BS2 S.A' },
    '292': { value: '292', label: 'BS2 DISTRIBUIDORA DE TÍTULOS E INVESTIMENTOS' },
    '169': { value: '169', label: 'BANCO OLÉ BONSUCESSO CONSIGNADO S.A' },
    '293': { value: '293', label: 'LASTRO RDV DTVM LTDA' },
    '285': { value: '285', label: 'FRENTE CC LTDA' },
    '080': { value: '080', label: 'B&T CC LTDA' },
    '753': { value: '753', label: 'NOVO BANCO CONTINENTAL S.A BM' },
    '222': { value: '222', label: 'BANCO CRÉDIT AGRICOLE BR S.A' },
    '754': { value: '754', label: 'BANCO SISTEMA' },
    '098': { value: '098', label: 'CREDIALIANÇA CCR' },
    '610': { value: '610', label: 'BANCO VR S.A' },
    '712': { value: '712', label: 'BANCO OURINVEST S.A' },
    '010': { value: '010', label: 'CREDICOAMO' },
    '283': { value: '283', label: 'RB CAPITAL INVESTIMENTOS DTVM LTDA' },
    '217': { value: '217', label: 'BANCO JOHN DEERE S.A' },
    '117': { value: '117', label: 'ADVANCED CC LTDA' },
    '336': { value: '336', label: 'BANCO C6 S.A - C6 BANK' },
    '654': { value: '654', label: 'BANCO DIGIMAIS S.A' },
};
const withdrawalBanksChile = {
    '012': { value: '012', label: 'Banco Del Estado De Chile' },
    '504': { value: '504', label: 'Banco Bbva ( Bilbao Vizcaya Argentaria Chile) / Banco Bhif' },
    '028': { value: '028', label: 'Banco Bice' },
    '055': { value: '055', label: 'Banco Consorcio' },
    '027': { value: '027', label: 'Banco Corpbanca' },
    '001': { value: '001', label: 'Banco De Chile / Banco A. Edwards / Credichile / Citybank' },
    '016': { value: '016', label: 'Banco De Crédito E Inversiones (BCI) / Tbanc' },
    '507': { value: '507', label: 'Banco Del Desarrollo' },
    '051': { value: '051', label: 'Banco Falabella' },
    '009': { value: '009', label: 'Banco Internacional' },
    '039': { value: '039', label: 'Banco Itau Chile / Bank Boston' },
    '053': { value: '053', label: 'Banco Ripley' },
    '057': { value: '057', label: 'Banco París' },
    '037': { value: '037', label: 'Banco Santander - Santiago / Banco Santander / Banefe' },
    '049': { value: '049', label: 'Banco Security' },
    '672': { value: '672', label: 'Coopeuch' },
    '031': { value: '031', label: 'Hsbc Bank (Chile)' },
    '014': { value: '014', label: 'Scotiabank / Sud - Americano' },
};
const withdrawalBanksMexico = {
    37006: { value: 37006, label: 'BANCOMEXT' },
    37009: { value: 37009, label: 'BANOBRAS' },
    37019: { value: 37019, label: 'BANJERCITO' },
    37135: { value: 37135, label: 'NAFIN' },
    37166: { value: 37166, label: 'BANSEFI' },
    37168: { value: 37168, label: 'HIPOTECARIA FED' },
    40002: { value: 40002, label: 'BANAMEX' },
    40012: { value: 40012, label: 'BBVA BANCOMER' },
    40014: { value: 40014, label: 'SANTANDER' },
    40021: { value: 40021, label: 'HSBC' },
    40030: { value: 40030, label: 'BAJIO' },
    40036: { value: 40036, label: 'INBURSA' },
    40042: { value: 40042, label: 'MIFEL' },
    40044: { value: 40044, label: 'SCOTIABANK' },
    40058: { value: 40058, label: 'BANREGIO' },
    40059: { value: 40059, label: 'INVEX' },
    40060: { value: 40060, label: 'BANSI' },
    40062: { value: 40062, label: 'AFIRME' },
    40072: { value: 40072, label: 'BANORTE' },
    40102: { value: 40102, label: 'ACCENDO BANCO' },
    40103: { value: 40103, label: 'AMERICAN EXPRESS' },
    40106: { value: 40106, label: 'BANK OF AMERICA' },
    40108: { value: 40108, label: 'MUFG' },
    40110: { value: 40110, label: 'JP MORGAN' },
    40112: { value: 40112, label: 'BMONEX' },
    40113: { value: 40113, label: 'VE POR MAS' },
    40124: { value: 40124, label: 'DEUSTCHE' },
    40126: { value: 40126, label: 'CREDIT SUISSE' },
    40127: { value: 40127, label: 'AZTECA' },
    40128: { value: 40128, label: 'AUTOFIN' },
    40129: { value: 40129, label: 'BARCLAYS' },
    40130: { value: 40130, label: 'COMPARTAMOS' },
    40131: { value: 40131, label: 'BANCO FAMSA' },
    40132: { value: 40132, label: 'MULTIVA BANCO' },
    40133: { value: 40133, label: 'ACTINVER' },
    40136: { value: 40136, label: 'INTERCAM BANCO' },
    40137: { value: 40137, label: 'BANCOPPEL' },
    40138: { value: 40138, label: 'ABC CAPITAL' },
    40140: { value: 40140, label: 'CONSUBANCO' },
    40141: { value: 40141, label: 'VOLKSWAGEN' },
    40143: { value: 40143, label: 'CIBANCO' },
    40145: { value: 40145, label: 'BBASE' },
    40147: { value: 40147, label: 'BANKAOOL' },
    40148: { value: 40148, label: 'PAGATODO' },
    40150: { value: 40150, label: 'INMOBILIARIO' },
    40151: { value: 40151, label: 'DONDE' },
    40152: { value: 40152, label: 'BANCREA' },
    40154: { value: 40154, label: 'BANCO FINTERRA' },
    40155: { value: 40155, label: 'ICBC' },
    40156: { value: 40156, label: 'SABADELL' },
    40157: { value: 40157, label: 'SHINHAN' },
    40158: { value: 40158, label: 'MIZUHO BANK' },
    40160: { value: 40160, label: 'BANCO S3' },
    90600: { value: 90600, label: 'MONEXCB' },
    90601: { value: 90601, label: 'GBM' },
    90602: { value: 90602, label: 'MASARI' },
    90605: { value: 90605, label: 'VALUE' },
    90606: { value: 90606, label: 'ESTRUCTURADORES' },
    90608: { value: 90608, label: 'VECTOR' },
    90613: { value: 90613, label: 'CBOLSA' },
    90616: { value: 90616, label: 'FINAMEX' },
    90617: { value: 90617, label: 'VALMEX' },
    90620: { value: 90620, label: 'PROFUTURO' },
    90630: { value: 90630, label: 'CB INTERCAM' },
    90631: { value: 90631, label: 'CI BOLSA' },
    90634: { value: 90634, label: 'FINCOMUN' },
    90636: { value: 90636, label: 'HDI SEGUROS' },
    90638: { value: 90638, label: 'AKALA' },
    90642: { value: 90642, label: 'REFORMA' },
    90646: { value: 90646, label: 'STP' },
    90648: { value: 90648, label: 'EVERCORE' },
    90652: { value: 90652, label: 'CREDICAPITAL' },
    90653: { value: 90653, label: 'KUSPIT' },
    90656: { value: 90656, label: 'UNAGRA' },
    90659: { value: 90659, label: 'ASP INTEGRA OPC' },
    90670: { value: 90670, label: 'CB LIBERTAD' },
    90677: { value: 90677, label: 'CAJA POP MEXICA' },
    90680: { value: 90680, label: 'CRISTOBAL COLON' },
    90683: { value: 90683, label: 'CAJA TELEFONIST' },
    90684: { value: 90684, label: 'TRANSFER' },
    90685: { value: 90685, label: 'FONDO (FIRA)' },
    90686: { value: 90686, label: 'INVERCAP' },
    90689: { value: 90689, label: 'FOMPED' },
    90902: { value: 90902, label: 'INDEVAL' },
    90903: { value: 90903, label: 'CoDi Valida' },
};
const withdrawalBanksColombia = {
    '0000': { value: '0000', label: 'BANCO DE LA REPUBLICA' },
    '0001': { value: '0001', label: 'BANCO DE BOGOTA' },
    '0002': { value: '0002', label: 'BANCO POPULAR' },
    '0006': { value: '0006', label: 'BANCO CORPBANCA COLOMBIA SA.' },
    '0007': { value: '0007', label: 'BANCOLOMBIA' },
    '0009': { value: '0009', label: 'CITIBANK' },
    '0012': { value: '0012', label: 'BANCO GNB SUDAMERIS' },
    '0013': { value: '0013', label: 'BBVA COLOMBIA' },
    '0019': { value: '0019', label: 'BANCO COLPATRIA' },
    '0023': { value: '0023', label: 'BANCO DE OCCIDENTE' },
    '0031': { value: '0031', label: 'BANCOLDEX' },
    '0032': { value: '0032', label: 'BANCO BCSC SA' },
    '0040': { value: '0040', label: 'BANCO AGRARIO' },
    '0041': { value: '0041', label: 'JPMORGAN CORPORACION FINANCIERA' },
    '0042': { value: '0042', label: 'BNP PARIBAS' },
    '0051': { value: '0051', label: 'BANCO DAVIVIENDA S.A.' },
    '0052': { value: '0052', label: 'BANCO AV VILLAS' },
    '0058': { value: '0058', label: 'BANCO PROCREDIT' },
    '0060': { value: '0060', label: 'BANCO PICHINCHA' },
    '0061': { value: '0061', label: 'BANCOOMEVA' },
    '0063': { value: '0063', label: 'BANCO FINANDINA' },
    '0065': { value: '0065', label: 'BANCO SANTANDER DE NEGOCIOS COLOMBIA SA' },
    '0066': { value: '0066', label: 'BANCO COOPERATIVO COOPCENTRAL' },
    '0083': { value: '0083', label: 'COMPENSAR' },
    '0084': { value: '0084', label: 'GESTION CONTACTO' },
    '0086': { value: '0086', label: 'ASOPAGOS' },
    '0087': { value: '0087', label: 'FEDECAJAS' },
    '0088': { value: '0088', label: 'SIMPLE S.A' },
    '0089': { value: '0089', label: 'ENLACE OPERATIVO' },
    '0283': { value: '0283', label: 'COOPERTIVA FINANCIERA ANTIOQUIA' },
    '0289': { value: '0289', label: 'COTRAFA COOPERATIVA FINANCIERA' },
    '0292': { value: '0292', label: 'CONFIAR' },
    '0370': { value: '0370', label: 'COLTEFINANCIERA S.A' },
    '0550': { value: '0550', label: 'DECEVAL' },
    '0683': { value: '0683', label: 'DGCPTN' },
    '0685': { value: '0685', label: 'DGCPTN * Sistema General de Regalias' },
    '0121': { value: '0121', label: 'FINANCIERA JURISCOP S.A. Compañía de Financiamiento' },
    '0064': { value: '0064', label: 'BANCO MULTIBANK S.A.' },
    '0067': { value: '0067', label: 'BANCO COMPARTIR S.A.' },
    '0062': { value: '0062', label: 'BANCO FALABELLA S.A.' },
    '0342': { value: '0342', label: 'SERFINANSA S.A.' },
};
const withdrawalBanksEcuador = {
    '0001': { value: '0001', label: 'BANCO AMAZONAS' },
    '0002': { value: '0002', label: 'BANCO BOLIVARIANO' },
    '0003': { value: '0003', label: 'BANCO CAPITAL' },
    '0004': { value: '0004', label: 'BANCO CENTRAL DEL ECUADOR' },
    '0005': { value: '0005', label: 'BANCO CITY BANK' },
    '0006': { value: '0006', label: 'BANCO COFIEC' },
    '0007': { value: '0007', label: 'BANCO COOPNACIONAL SA' },
    '0008': { value: '0008', label: 'BANCO D MIRO SA' },
    '0009': { value: '0009', label: 'BANCO DE FOMENTO' },
    '0010': { value: '0010', label: 'BANCO DE GUAYAQUIL S.A' },
    '0011': { value: '0011', label: 'BANCO DE LA PRODUCCION' },
    '0012': { value: '0012', label: 'BANCO DE LOJA' },
    '0013': { value: '0013', label: 'BANCO DEL AUSTRO' },
    '0014': { value: '0014', label: 'BANCO DEL INSTITU ECUATORIANO DE SEGURIDAD SOCIAL' },
    '0015': { value: '0015', label: 'BANCO DEL LITORAL S.A.' },
    '0016': { value: '0016', label: 'BANCO DEL PACIFICO' },
    '0017': { value: '0017', label: 'BANCO DELBANK S.A.' },
    '0018': { value: '0018', label: 'BANCO ECUATORIANO DE LA VIVIENDA' },
    '0019': { value: '0019', label: 'BANCO GENERAL RUMINAHUI S.A.' },
    '0020': { value: '0020', label: 'BANCO INTERNACIONAL' },
    '0021': { value: '0021', label: 'BANCO MACHALA' },
    '0022': { value: '0022', label: 'BANCO PARA LA ASISTENCIA COMUNITARIA FINCA S.A.' },
    '0023': { value: '0023', label: 'BANCO PICHINCHA C.A.' },
    '0024': { value: '0024', label: 'BANCO PROCREDIT S.A.' },
    '0025': { value: '0025', label: 'BANCO PROMERICA S.A.' },
    '0026': { value: '0026', label: 'BANCO SOLIDARIO' },
    '0027': { value: '0027', label: 'BANCO SUDAMERICANO' },
    '0028': { value: '0028', label: 'C DE A Y C EMPLEAD BANCAR DEL ORO LTDA' },
    '0029': { value: '0029', label: 'C. A. Y C. INTERCULT. TARPUK RUNA LTDA.' },
    '0030': { value: '0030', label: 'C. DE A Y C 26 DE SEPTBRE LAZARO CONDO' },
    '0031': { value: '0031', label: 'C. DE A Y C 4 DE OCT. SAN FCO. DE CHAMBO' },
    '0032': { value: '0032', label: 'C. DE A Y C EDUCAD. DE ZAMORA CHINCHIPE' },
    '0033': { value: '0033', label: 'C. DE A Y C. EDUCADORES DE EL ORO LTD' },
    '0034': { value: '0034', label: 'C. DE A Y C. SAN MIGUEL DE PALLATANGA' },
    '0035': { value: '0035', label: 'C. DE A. Y C COOPAC AUSTRO LTDA (MIESS)' },
    '0036': { value: '0036', label: 'C. DE A. Y C. SAN MARTIN DE TISALEO LTDA.' },
    '0037': { value: '0037', label: 'C. DE AH. Y CREDITO LAS LAGUNAS (MIESS)' },
    '0038': { value: '0038', label: 'C.PEQ.EMPRESA DE PASTAZA' },
    '0039': { value: '0039', label: 'CACPECO LTDA' },
    '0040': { value: '0040', label: 'CAJA DE A Y C JUVENTUD Y DESARROLLO' },
    '0041': { value: '0041', label: 'CAJA DE A Y C NUESTRA SENORA DE LA MERCED' },
    '0042': { value: '0042', label: 'CAJA DE AHORRO Y CREDITO EL INGENIO' },
    '0043': { value: '0043', label: 'CAJA DE AHORRO Y CREDITO EL MANIZAL' },
    '0044': { value: '0044', label: 'CAJA DE AHORRO Y CREDITO FRANCISCA CHIGUA' },
    '0045': { value: '0045', label: 'CAJA DE AHORRO Y CREDITO FRONTERA SUR' },
    '0046': { value: '0046', label: 'CAJA DE AHORRO Y CREDITO HORIZONTE FAMILIAR' },
    '0047': { value: '0047', label: 'CAJA DE AHORRO Y CREDITO MANU' },
    '0048': { value: '0048', label: 'CAJA DE AHORRO Y CREDITO SAN FRANCISCO' },
    '0049': { value: '0049', label: 'CAJA DE AHORRO Y CREDITO ZHONDELEG' },
    '0050': { value: '0050', label: 'CAJA SOLIDARIA DE A Y C CORDTUCH' },
    '0051': { value: '0051', label: 'CAJA SOLIDARIA ESTRELLA DEL MUNDO' },
    '0052': { value: '0052', label: 'CAMARA DE COMERCIO JOYA DE LOS SACHAS' },
    '0053': { value: '0053', label: 'COMERCIAL DE MANABI' },
    '0054': { value: '0054', label: 'COOP A Y C 20 FEBRERO LTDA' },
    '0055': { value: '0055', label: 'COOP A Y C CARROCEROS DE TUNGURAHUA' },
    '0056': { value: '0056', label: 'COOP A Y C ECUAFUTURO LTDA' },
    '0057': { value: '0057', label: 'COOP A Y C ESC SUP POLITEC AGROP DE MANABI MANUEL' },
    '0058': { value: '0058', label: 'COOP A Y C FOCLA' },
    '0059': { value: '0059', label: 'COOP A Y C HUINARA LTDA' },
    '0060': { value: '0060', label: 'COOP A Y C NUEVOS HORIZONTES EL ORO LTDA' },
    '0061': { value: '0061', label: 'COOP A Y C PROFESIONALES DEL VOLANTE UNION LTDA' },
    '0062': { value: '0062', label: 'COOP AHORRO Y CREDITO CAMARA COMERCIO DE AMBATO' },
    '0063': { value: '0063', label: 'COOP AHORRO Y CREDITO CARIAMANGA LTDA' },
    '0064': { value: '0064', label: 'COOP AHORRO Y CREDITO CONSTRC COMERCIO Y PRODUC' },
    '0065': { value: '0065', label: 'COOP AHORRO Y CREDITO DE LA PEQ EMP CACPE YANZATZA' },
    '0066': { value: '0066', label: 'COOP AHORRO Y CREDITO FUNDESARROLLO' },
    '0067': { value: '0067', label: 'COOP AHORRO Y CREDITO MI TIERRA' },
    '0068': { value: '0068', label: 'COOP AHORRO Y CREDITO MUSHUC RUNA LTDA' },
    '0069': { value: '0069', label: 'COOP AHORRO Y CREDITO PADRE JULIAN LORENTE LTDA' },
    '0070': { value: '0070', label: 'COOP AHORRO Y CREDITO PEQ EMPRESA GUALAQUIZA' },
    '0071': { value: '0071', label: 'COOP CACIQUE GURITAVE' },
    '0072': { value: '0072', label: 'COOP CREDIUNION' },
    '0073': { value: '0073', label: 'COOP DE A Y C 16 DE JUNIO' },
    '0074': { value: '0074', label: 'COOP DE A Y C 23 DE MAYO LTDA' },
    '0075': { value: '0075', label: 'COOP DE A Y C ACCION TUNGURAHUA LTDA' },
    '0076': { value: '0076', label: 'COOP DE A Y C BANOS LTDA' },
    '0077': { value: '0077', label: 'COOP DE A Y C CAMARA DE COMERICO GONZANAMA' },
    '0078': { value: '0078', label: 'COOP DE A Y C CASAG LTDA' },
    '0079': { value: '0079', label: 'COOP DE A Y C CATAMAYO LTDA' },
    '0080': { value: '0080', label: 'COOP DE A Y C COCA LTDA' },
    '0081': { value: '0081', label: 'COOP DE A Y C CREDIAMIGO LTDA LOJA MIES' },
    '0082': { value: '0082', label: 'COOP DE A Y C CREDISUR LTDA' },
    '0083': { value: '0083', label: 'COOP DE A Y C DE LA PEQ EMPRESA CACPE MACARA' },
    '0084': { value: '0084', label: 'COOP DE A Y C DE SERV PUBL DEL MIN EDUCACION Y CUL' },
    '0085': { value: '0085', label: 'COOP DE A Y C DEL COL. FISC. VICENTE ROCAFUERTE' },
    '0086': { value: '0086', label: 'COOP DE A Y C DESARROLLO POPULAR' },
    '0087': { value: '0087', label: 'COOP DE A Y C EDUCACIONES TULCAN LTDA' },
    '0088': { value: '0088', label: 'COOP DE A Y C EDUCADORES DE PASTAZA LTDA' },
    '0089': { value: '0089', label: 'COOP DE A Y C EDUCADORES TULCAN LTDA' },
    '0090': { value: '0090', label: 'COOP DE A Y C ESCENCIA INDIGENA LTDA' },
    '0091': { value: '0091', label: 'COOP DE A Y C FENIX' },
    '0092': { value: '0092', label: 'COOP DE A Y C FINANCIERA INDIGENA LTDA' },
    '0093': { value: '0093', label: 'COOP DE A Y C FUTURO Y PROGRESO DE GALAPAGOS LTDA' },
    '0094': { value: '0094', label: 'COOP DE A Y C GENERAL RUMINAHUI' },
    '0095': { value: '0095', label: 'COOP DE A Y C GONZANAMA MIES' },
    '0096': { value: '0096', label: 'COOP DE A Y C INKA KIPU LTDA' },
    '0097': { value: '0097', label: 'COOP DE A Y C JADAN LTDA (MIES)' },
    '0098': { value: '0098', label: 'COOP DE A Y C LUCHA CAMPESINA LTDA' },
    '0099': { value: '0099', label: 'COOP DE A Y C MAQUITA CUSHUN LTDA' },
    '0100': { value: '0100', label: 'COOP DE A Y C MAQUITA CUSHUNCHIC LTDA' },
    '0101': { value: '0101', label: 'COOP DE A Y C MUSHUK YUYAY' },
    '0102': { value: '0102', label: 'COOP DE A Y C PIJAL' },
    '0103': { value: '0103', label: 'COOP DE A Y C SAN SANTIAGO DE MOLLETURO LTDA' },
    '0104': { value: '0104', label: 'COOP DE A Y C SANTA ROSA DE PAUTAN LTDA' },
    '0105': { value: '0105', label: 'COOP DE A Y C SIERRA CENTRO LTDA' },
    '0106': { value: '0106', label: 'COOP DE A Y C SINCHI RUNA LTDA' },
    '0107': { value: '0107', label: 'COOP DE A Y C SUMAC LLACTA LTDA' },
    '0108': { value: '0108', label: 'COOP DE A Y C UNION MERCEDARIA LTDA' },
    '0109': { value: '0109', label: 'COOP DE A Y C VALLES DEL LIRIO' },
    '0110': { value: '0110', label: 'COOP DE A Y C VENCEDORES DE TUNGURAHUA' },
    '0111': { value: '0111', label: 'COOP DE A Y C WUAMANLOMA' },
    '0112': { value: '0112', label: 'COOP DE AHORRO Y CREDITO 22 DE JUNIO' },
    '0113': { value: '0113', label: 'COOP DE AHORRO Y CREDITO 23 DE ENERO' },
    '0114': { value: '0114', label: 'COOP DE AHORRO Y CREDITO 27 DE ABRIL LOJA' },
    '0115': { value: '0115', label: 'COOP DE AHORRO Y CREDITO 29 DE ENERO' },
    '0116': { value: '0116', label: 'COOP DE AHORRO Y CREDITO AGRICOLA JUNIN LTDA' },
    '0117': { value: '0117', label: 'COOP DE AHORRO Y CREDITO AMBATO LTDA' },
    '0118': { value: '0118', label: 'COOP DE AHORRO Y CREDITO ARTESANOS LTDA' },
    '0119': { value: '0119', label: 'COOP DE AHORRO Y CREDITO CAC-CICA MIES' },
    '0120': { value: '0120', label: 'COOP DE AHORRO Y CREDITO CACPE CELICA' },
    '0121': { value: '0121', label: 'COOP DE AHORRO Y CREDITO CUMBENITA LTDA' },
    '0122': { value: '0122', label: 'COOP DE AHORRO Y CREDITO DORADO LTDA' },
    '0123': { value: '0123', label: 'COOP DE AHORRO Y CREDITO ERCO LTDA' },
    '0124': { value: '0124', label: 'COOP DE AHORRO Y CREDITO FASAYNAN LTDA' },
    '0125': { value: '0125', label: 'COOP DE AHORRO Y CREDITO FERNANDO DAQUILEMA' },
    '0126': { value: '0126', label: 'COOP DE AHORRO Y CREDITO FORTUNA MIES' },
    '0127': { value: '0127', label: 'COOP DE AHORRO Y CREDITO GUACHAPALA LTDA' },
    '0128': { value: '0128', label: 'COOP DE AHORRO Y CREDITO GUEL LTDA' },
    '0129': { value: '0129', label: 'COOP DE AHORRO Y CREDITO HUAICANA LTDA' },
    '0130': { value: '0130', label: 'COOP DE AHORRO Y CREDITO HUAQUILLAS LTDA' },
    '0131': { value: '0131', label: 'COOP DE AHORRO Y CREDITO HUAYCO PUNGO LTDA' },
    '0132': { value: '0132', label: 'COOP DE AHORRO Y CREDITO INTEGRAL' },
    '0133': { value: '0133', label: 'COOP DE AHORRO Y CREDITO LA FLORIDA' },
    '0134': { value: '0134', label: 'COOP DE AHORRO Y CREDITO LA MERCED' },
    '0135': { value: '0135', label: 'COOP DE AHORRO Y CREDITO MARCABELI LTDA' },
    '0136': { value: '0136', label: 'COOP DE AHORRO Y CREDITO MIGRANTE SOLIDARIO' },
    '0137': { value: '0137', label: 'COOP DE AHORRO Y CREDITO NUESTROS ABUELOS LTDA' },
    '0138': { value: '0138', label: 'COOP DE AHORRO Y CREDITO NUEVA ESPERANZA' },
    '0139': { value: '0139', label: 'COOP DE AHORRO Y CREDITO NUEVA HUANCAVILCA' },
    '0140': { value: '0140', label: 'COOP DE AHORRO Y CREDITO PILAHUIN TIO LTDA' },
    '0141': { value: '0141', label: 'COOP DE AHORRO Y CREDITO POPULAR Y SOLIDARIA' },
    '0142': { value: '0142', label: 'COOP DE AHORRO Y CREDITO PUERTO LOPEZ LTDA' },
    '0143': { value: '0143', label: 'COOP DE AHORRO Y CREDITO QUILANGA LTDA' },
    '0144': { value: '0144', label: 'COOP DE AHORRO Y CREDITO SAN JORGE LTDA' },
    '0145': { value: '0145', label: 'COOP DE AHORRO Y CREDITO SAN JOSE EL AIRO' },
    '0146': { value: '0146', label: 'COOP DE AHORRO Y CREDITO SAN MIGUEL DE SIGCHOS' },
    '0147': { value: '0147', label: 'COOP DE AHORRO Y CREDITO SAN PEDRO DE TABOADA' },
    '0148': { value: '0148', label: 'COOP DE AHORRO Y CREDITO SANTA ANITA LTDA' },
    '0149': { value: '0149', label: 'COOP DE AHORRO Y CREDITO SIMIATUG LTDA' },
    '0150': { value: '0150', label: 'COOP DE LA PEQ Y MEDIANA EMPR CIUDADANA DE MACARA' },
    '0151': { value: '0151', label: 'COOP DE SERV MULTIPLES AGRO VIDA' },
    '0152': { value: '0152', label: 'COOP ESFUERZO UNIDO PARA EL DESARR DEL CHILCO' },
    '0153': { value: '0153', label: 'COOP MANUEL ESTEBAN GODOY ORTEGA LTDA COOPMEGO' },
    '0154': { value: '0154', label: 'COOP OLMEDO' },
    '0155': { value: '0155', label: 'COOP SOLIDARIA DE GUALAQUIZA' },
    '0156': { value: '0156', label: 'COOP SOLIDARIDAD Y PROGRESO ORIENTAL' },
    '0157': { value: '0157', label: 'COOP. 15 DE DICIEMBRE' },
    '0158': { value: '0158', label: 'COOP. A. Y C. CAMARA DE COMERCIO DE PINDAL CADECOP' },
    '0159': { value: '0159', label: 'COOP. A. Y C. DE LA PEQ. EMP. CACPE ZAMORA LTDA' },
    '0160': { value: '0160', label: 'COOP. AGUILAS DE CRISTO' },
    '0161': { value: '0161', label: 'COOP. AHORRO Y CREDITO 15 DE ABRIL LTDA' },
    '0162': { value: '0162', label: 'COOP. AHORRO Y CREDITO 23 DE JULIO' },
    '0163': { value: '0163', label: 'COOP. AHORRO Y CREDITO 29 DE OCTUBRE' },
    '0164': { value: '0164', label: 'COOP. AHORRO Y CREDITO 9 DE OCTUBRE LTDA' },
    '0165': { value: '0165', label: 'COOP. AHORRO Y CREDITO ACCION RURAL' },
    '0166': { value: '0166', label: 'COOP. AHORRO Y CREDITO ALIANZA MINAS LTDA.' },
    '0167': { value: '0167', label: 'COOP. AHORRO Y CREDITO AMAZONAS LTDA.' },
    '0168': { value: '0168', label: 'COOP. AHORRO Y CREDITO ANDALUCIA' },
    '0169': { value: '0169', label: 'COOP. AHORRO Y CREDITO COTOCOLLAO' },
    '0170': { value: '0170', label: 'COOP. AHORRO Y CREDITO D LA PEQ EMPR CACPE BIBLIAN' },
    '0171': { value: '0171', label: 'COOP. AHORRO Y CREDITO DE LA PEQUENA EMPRESA GUALA' },
    '0172': { value: '0172', label: 'COOP. AHORRO Y CREDITO DESARROLLO PUEBLOS' },
    '0173': { value: '0173', label: 'COOP. AHORRO Y CREDITO EL SAGRARIO' },
    '0174': { value: '0174', label: 'COOP. AHORRO Y CREDITO FAMILIA AUSTRAL' },
    '0175': { value: '0175', label: 'COOP. AHORRO Y CREDITO GUARANDA LTDA' },
    '0176': { value: '0176', label: 'COOP. AHORRO Y CREDITO JUAN DE SALINAS LTDA.' },
    '0177': { value: '0177', label: 'COOP. AHORRO Y CREDITO JUVENTUD' },
    '0178': { value: '0178', label: 'COOP. AHORRO Y CREDITO LOS RIOS' },
    '0179': { value: '0179', label: 'COOP. AHORRO Y CREDITO MALCHINGUI LTDA.' },
    '0180': { value: '0180', label: 'COOP. AHORRO Y CREDITO MANANTIAL DE ORO LTDA.' },
    '0181': { value: '0181', label: 'COOP. AHORRO Y CREDITO MANUEL' },
    '0182': { value: '0182', label: 'COOP. AHORRO Y CREDITO NUEVA JERUSALEN' },
    '0183': { value: '0183', label: 'COOP. AHORRO Y CREDITO OSCUS' },
    '0184': { value: '0184', label: 'COOP. AHORRO Y CREDITO PABLO MUNOZ VEGA' },
    '0185': { value: '0185', label: 'COOP. AHORRO Y CREDITO PROGRESO' },
    '0186': { value: '0186', label: 'COOP. AHORRO Y CREDITO PUELLARO LTDA' },
    '0187': { value: '0187', label: 'COOP. AHORRO Y CREDITO RIOBAMBA' },
    '0188': { value: '0188', label: 'COOP. AHORRO Y CREDITO SAN FRANCISCO' },
    '0189': { value: '0189', label: 'COOP. AHORRO Y CREDITO SAN GABRIEL LTDA.' },
    '0190': { value: '0190', label: 'COOP. AHORRO Y CREDITO SAN JOSE LTDA' },
    '0191': { value: '0191', label: 'COOP. AHORRO Y CREDITO SAN MIGUEL DE LOS BANCOS' },
    '0192': { value: '0192', label: 'COOP. AHORRO Y CREDITO SEMILLA DEL PROGRESO LTDA' },
    '0193': { value: '0193', label: 'COOP. AHORRO Y CREDITO SENOR DE GIRON' },
    '0194': { value: '0194', label: 'COOP. AHORRO Y CREDITO TENA LTDA.' },
    '0195': { value: '0195', label: 'COOP. AHORRO Y CREDITO TULCAN' },
    '0196': { value: '0196', label: 'COOP. AHORRO. Y CREDI. MUJERES UNIDAS TANTANAKUSHK' },
    '0197': { value: '0197', label: 'COOP. CALCETA LTDA' },
    '0198': { value: '0198', label: 'COOP. CREDITO Y AHORRO SAN FRANCISCO DE ASIS' },
    '0199': { value: '0199', label: 'COOP. DE A Y C. SERVIDORES MUNICIPALES DE CUENCA' },
    '0200': { value: '0200', label: 'COOP. DE A. Y C. 13 DE ABRIL LTDA' },
    '0201': { value: '0201', label: 'COOP. DE A. Y C. ALLI TARPUC LTDA.' },
    '0202': { value: '0202', label: 'COOP. DE A. Y C. CHIBULEO LTDA.' },
    '0203': { value: '0203', label: 'COOP. DE A. Y C. COOPINDIGENA LTDA.' },
    '0204': { value: '0204', label: 'COOP. DE A. Y C. DESARROLLO INTEGRAL LTDA' },
    '0205': { value: '0205', label: 'COOP. DE A. Y C. EL TESORO PILLARENO' },
    '0206': { value: '0206', label: 'COOP. DE A. Y C. EL TRANSPORTISTA CACET' },
    '0207': { value: '0207', label: 'COOP. DE A. Y C. GRAMEEN AMAZONAS' },
    '0208': { value: '0208', label: 'COOP. DE A. Y C. ILINIZA LTDA.' },
    '0209': { value: '0209', label: 'COOP. DE A. Y C. INDIGENA ALFA Y OMEGA LTDA' },
    '0210': { value: '0210', label: 'COOP. DE A. Y C. JUAN PIO DE MORA LTDA' },
    '0211': { value: '0211', label: 'COOP. DE A. Y C. JUVENTUD UNIDA LTDA.' },
    '0212': { value: '0212', label: 'COOP. DE A. Y C. KISAPINCHA LTDA.' },
    '0213': { value: '0213', label: 'COOP. DE A. Y C. LA UNION LTDA.' },
    '0214': { value: '0214', label: 'COOP. DE A. Y C. LOS CHASQUIS PASTOCALLE LTDA.' },
    '0215': { value: '0215', label: 'COOP. DE A. Y C. MUSHUG CAUSAY LTDA.' },
    '0216': { value: '0216', label: 'COOP. DE A. Y C. PADRE VICENTE PONCE RUBIO' },
    '0217': { value: '0217', label: 'COOP. DE A. Y C. SALASACA' },
    '0218': { value: '0218', label: 'COOP. DE A. Y C. SALINAS LTDA.' },
    '0219': { value: '0219', label: 'COOP. DE A. Y C. SAN PEDRO LTDA.' },
    '0220': { value: '0220', label: 'COOP. DE A. Y C. SUMAK SAMY LTDA.' },
    '0221': { value: '0221', label: 'COOP. DE A. Y C. UNION QUISAPINCHA LTDA.' },
    '0222': { value: '0222', label: 'COOP. DE A. Y C. VIRGEN DEL CISNE' },
    '0223': { value: '0223', label: 'COOP. DE AHO Y CRED LOS ANDES LATINOS LTDA.' },
    '0224': { value: '0224', label: 'COOP. DE AHORRO Y CRED. SANTA ROSA LTDA' },
    '0225': { value: '0225', label: 'COOP. DE AHORRO Y CREDITO 4 DE OCTUBRE LTDA.' },
    '0226': { value: '0226', label: 'COOP. DE AHORRO Y CREDITO ACCION Y DESARROLLO LTDA' },
    '0227': { value: '0227', label: 'COOP. DE AHORRO Y CREDITO ANDINA LTDA.' },
    '0228': { value: '0228', label: 'COOP. DE AHORRO Y CREDITO ATUNTAQUI LTDA.' },
    '0229': { value: '0229', label: 'COOP. DE AHORRO Y CREDITO COMERCIO LTDA PORTOVIEJO' },
    '0230': { value: '0230', label: 'COOP. DE AHORRO Y CREDITO COOPERA LTDA.' },
    '0231': { value: '0231', label: 'COOP. DE AHORRO Y CREDITO CRISTO REY' },
    '0232': { value: '0232', label: 'COOP. DE AHORRO Y CREDITO EDUCADORES DE CHIMBORAZO' },
    '0233': { value: '0233', label: 'COOP. DE AHORRO Y CREDITO EL CALVARIO LTDA' },
    '0234': { value: '0234', label: 'COOP. DE AHORRO Y CREDITO GUARUMAL DEL CENTRO LTDA' },
    '0235': { value: '0235', label: 'COOP. DE AHORRO Y CREDITO LA DOLOROSA LTDA' },
    '0236': { value: '0236', label: 'COOP. DE AHORRO Y CREDITO ONCE DE JUNIO' },
    '0237': { value: '0237', label: 'COOP. DE AHORRO Y CREDITO PEDRO MONCAYO LTDA.' },
    '0238': { value: '0238', label: 'COOP. DE AHORRO Y CREDITO PILAHUIN' },
    '0239': { value: '0239', label: 'COOP. DE AHORRO Y CREDITO PROFUTURO LTDA.' },
    '0240': { value: '0240', label: 'COOP. DE AHORRO Y CREDITO PUCARA LTDA' },
    '0241': { value: '0241', label: 'COOP. DE AHORRO Y CREDITO SARAGUROS' },
    '0242': { value: '0242', label: 'COOP. DE LA MICROEMP. DE CHIMBORAZO' },
    '0243': { value: '0243', label: 'COOP. JARDIN AZUAYO' },
    '0244': { value: '0244', label: 'COOP. PREVISION AHORRO Y DESARROLLO' },
    '0245': { value: '0245', label: 'COOP. PROD. Y DES. AGR. COOPRODESA LTDA' },
    '0246': { value: '0246', label: 'COOP. SAN PABLO' },
    '0247': { value: '0247', label: 'COOP.AHO Y CREDITO DE LA PEQ. EMP. DE LOJA CACPE' },
    '0248': { value: '0248', label: 'COOP.AHORRO Y CREDITO ALIANZA DEL VALLE LTDA' },
    '0249': { value: '0249', label: 'COOP.AHORRO Y CREDITO CHONE LTDA' },
    '0250': { value: '0250', label: 'COOP.AHORRO Y CREDITO PRIMERO DE ENERO DEL AUSTRO' },
    '0251': { value: '0251', label: 'COOP.DE AHORRO Y CREDITO POLICIA NACIONAL' },
    '0252': { value: '0252', label: 'COOPERATIVA 15 DE AGOSTO PILACOTO' },
    '0253': { value: '0253', label: 'COOPERATIVA DE AH. Y CREDITO RIOCHICO' },
    '0254': { value: '0254', label: 'COOPERATIVA DE AHORRO Y CREDITO ALFONSO JARAMILLO' },
    '0255': { value: '0255', label: 'COOPERATIVA DE AHORRO Y CREDITO CASA FACIL LTDA.' },
    '0256': { value: '0256', label: 'COOPERATIVA DE AHORRO Y CREDITO CREA LTDA ( MIES)' },
    '0257': { value: '0257', label: 'COOPERATIVA DE AHORRO Y CREDITO INTI WASI LTDA.' },
    '0258': { value: '0258', label: 'COOPERATIVA DE AHORRO Y CREDITO LLANGANATES' },
    '0259': { value: '0259', label: 'COOPERATIVA DE AHORRO Y CREDITO MINGA LTDA.' },
    '0260': { value: '0260', label: 'COOPERATIVA DE AHORRO Y CREDITO PROVIDA' },
    '0261': { value: '0261', label: 'COOPERATIVA DE AHORRO Y CREDITO SAN ISIDRO LTDA.' },
    '0262': { value: '0262', label: 'COOPERATIVA DE AHORRO Y CREDITO SAN JOSE S.J.' },
    '0263': { value: '0263', label: 'COOPERATIVA DE AHORRO Y CREDITO SANTA ANA LTDA' },
    '0264': { value: '0264', label: 'CORP. DE DES. SOCIAL Y FINANC ISLAS ENCANTADAS' },
    '0265': { value: '0265', label: 'CORPORACION DE DESARROLLO FINANCIERA RHUMY WARA' },
    '0266': { value: '0266', label: 'CORPORACION EN LAS HUELLAS DEL BCO GRAMEEN' },
    '0267': { value: '0267', label: 'CORPORACION VIENTOS SOLIDARIOS' },
    '0268': { value: '0268', label: 'DE AHORRO Y CREDITO CRECIENDO JUNTOS' },
    '0269': { value: '0269', label: 'DE AHORRO Y CREDITO FCO. DE ORELLANA' },
    '0270': { value: '0270', label: 'FINANCIERA - DINERS CLUB DEL ECUADOR' },
    '0271': { value: '0271', label: 'FINANCIERA CONSULCREDITOS SA' },
    '0272': { value: '0272', label: 'FINANCOOP' },
    '0273': { value: '0273', label: 'FONDO DE CESANTIA DEL MAGISTERIO ECUAT FCME-FCPC' },
    '0274': { value: '0274', label: 'INTERDIN S.A.' },
    '0275': { value: '0275', label: 'MUTUALISTA AMBATO' },
    '0276': { value: '0276', label: 'MUTUALISTA AZUAY' },
    '0277': { value: '0277', label: 'MUTUALISTA IMBABURA' },
    '0278': { value: '0278', label: 'MUTUALISTA PICHINCHA' },
    '0279': { value: '0279', label: 'VAZCORP SOCIEDAD FINANCIERA S.A.' },
};
const withdrawalBanksPeru = {
    '0001': { value: '0001', label: 'BANCO INTERNACIONAL DEL PERU (INTERBANK)' },
    '0002': { value: '0002', label: 'BANCO BBVA PERU' },
    '0003': { value: '0003', label: 'BANCO BCP PERU' },
    '0004': { value: '0004', label: 'BANCO SCOTIABANK PERU' },
};
export const payRetailersWithdrawalBanks = {
    br: generateKeys(withdrawalBanksBrazil),
    cl: generateKeys(withdrawalBanksChile),
    mx: generateKeys(withdrawalBanksMexico),
    co: generateKeys(withdrawalBanksColombia),
    ec: generateKeys(withdrawalBanksEcuador),
    pe: generateKeys(withdrawalBanksPeru),
};
const documentTypesBrazil = {
    1: { value: 1, label: 'CPF' },
};
const documentTypesChile = {
    cl_rut: { value: 'cl_rut', label: 'RUT' },
};
const documentTypesMexico = {
    40: { value: 40, label: 'General' },
};
const documentTypesColombia = {
    '01': { value: '01', label: 'Cedula Ciudadanía (CC)' },
    '02': { value: '02', label: 'Cedular de Extranjería (CE)' },
    '03': { value: '03', label: 'NIT (NT)' },
    '04': { value: '04', label: 'Tarjeta de Identidad (TI)' },
    '06': { value: '06', label: 'NII de Establecimientos (NE)' },
};
const documentTypesEcuador = {
    '04': { value: '04', label: 'DNI/Identification Card' },
};
const documentTypesPeru = {
    '04': { value: '04', label: 'DNI/Identification Card' },
};
export const payRetailersDocumentTypes = {
    br: generateKeys(documentTypesBrazil),
    cl: generateKeys(documentTypesChile),
    mx: generateKeys(documentTypesMexico),
    co: generateKeys(documentTypesColombia),
    ec: generateKeys(documentTypesEcuador),
    pe: generateKeys(documentTypesPeru),
};
const bankAccountTypesBrazil = {
    '0001': { value: '0001', label: 'Poupança' },
    '0002': { value: '0002', label: 'Conta Corrente' },
};
const bankAccountTypesChile = {
    '0001': { value: '0001', label: 'Cuenta Corriente / Cueta Vista (All Banks)' },
    '0002': { value: '0002', label: 'Cuenta de ahorro (All Banks)' },
    '0003': { value: '0003', label: 'Chequera electrónica (Banco Estado)' },
    '0004': { value: '0004', label: 'Cuenta RUT (Banco Estado)' },
};
const bankAccountTypesMexico = {
    '0001': { value: '0001', label: 'General' },
};
const bankAccountTypesColombia = {
    '0001': { value: '0001', label: 'Ahorros' },
    '0002': { value: '0002', label: 'Corriente' },
};
const bankAccountTypesEcuador = {
    '0001': { value: '0001', label: 'Savings Bank' },
    '0002': { value: '0002', label: 'Checking Account' },
};
const bankAccountTypesPeru = {
    '0001': { value: '0001', label: 'Savings Bank' },
    '0002': { value: '0002', label: 'Checking Account' },
};
export const payRetailersBankAccountTypes = {
    br: generateKeys(bankAccountTypesBrazil),
    cl: generateKeys(bankAccountTypesChile),
    mx: generateKeys(bankAccountTypesMexico),
    co: generateKeys(bankAccountTypesColombia),
    ec: generateKeys(bankAccountTypesEcuador),
    pe: generateKeys(bankAccountTypesPeru),
};
const payoutBeneficiaryTypeCodes = {
    person: {
        value: 'person',
        label: 'Person',
    },
    company: {
        value: 'company',
        label: 'Company',
    },
};
export const payRetailersPayoutBeneficiaryTypeCodes = generateKeys(payoutBeneficiaryTypeCodes);
